
import { Union } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { union_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { StringModule_Split, StringModule_Concat } from "../Common/EEExtensions.js";
import { delay, toArray as toArray_1, toList, map, truncate } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { isLetterOrDigit } from "../fable_modules/fable-library-js.5.13.0/Char.js";
import { replicate as replicate_1, append as append_1, take, toArray as toArray_2, empty, map3, fold, initialize, map as map_2, head, isEmpty, ofArray } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { Array_groupBy, Array_distinctBy } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { comparePrimitives, compareArrays, int32ToString, equals, stringHash } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { chunkBySize, unzip, sort, item, concat as concat_1, append, iterateIndexed, sortBy, map as map_1, mapIndexed, collect } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { format, replicate, printf, toFail, interpolate, toText, concat } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { toArray } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { isHybridComponent } from "../Simulator/SynchronousUtils.js";
import { fromZero, fromInt32, fromOne, op_LeftShift, op_Subtraction, op_BitwiseAnd } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { hexBignum } from "../Simulator/NumberHelpers.js";
import { FastSimulation__ComponentAt_3B11D6BA } from "../Simulator/SimTypes.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { isOutput } from "../Common/Helpers.js";
import { max } from "../fable_modules/fable-library-js.5.13.0/Double.js";

export class VMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ForSynthesis", "ForSimulation"];
    }
    static ForSynthesis = new VMode(0, []);
    static ForSimulation = new VMode(1, []);
}

export function VMode_$reflection() {
    return union_type("Verilog.VMode", [], VMode, () => [[], []]);
}

export class CompilationProfile extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Release", "Debug"];
    }
    static Release = new CompilationProfile(0, []);
    static Debug = new CompilationProfile(1, []);
}

export function CompilationProfile_$reflection() {
    return union_type("Verilog.CompilationProfile", [], CompilationProfile, () => [[], []]);
}

const maxIdentifierLength = 50;

function capLength(s) {
    if (s.length > maxIdentifierLength) {
        return s.slice(undefined, (maxIdentifierLength - 1) + 1);
    }
    else {
        return s;
    }
}

/**
 * take FullName and convert it into a verilog compatible form
 * this is not 1-1, so outputs may not be unique, that is OK
 */
export function verilogNameConvert(maxChars, s) {
    let _arg;
    return capLength(StringModule_Concat("", truncate(maxChars, map((_arg_1) => {
        let ch;
        if ((ch = _arg_1, isLetterOrDigit(ch) ? true : (ch === "_"))) {
            return _arg_1;
        }
        else {
            return "";
        }
    }, ((_arg = ofArray(StringModule_Split(["("], s)), isEmpty(_arg) ? "x" : head(_arg))).split("")))));
}

/**
 * simple way to assign to each component and component output a unique verilog compatible name.
 * outputs will become reg or wire signals in the Verilog
 */
export function writeVerilogNames(fs) {
    const disambiguate = (names_mut) => {
        disambiguate:
        while (true) {
            const names = names_mut;
            if (Array_distinctBy((tuple) => tuple[0], names, {
                Equals: (x_1, y_1) => (x_1 === y_1),
                GetHashCode: (x_1) => (stringHash(x_1) | 0),
            }).length === names.length) {
                return names;
            }
            else {
                names_mut = collect((tupledArg) => {
                    const groupA = tupledArg[1];
                    if (groupA.length === 1) {
                        return groupA;
                    }
                    else {
                        return mapIndexed((i, tupledArg_1) => [`${tupledArg_1[0]}$${i}`, tupledArg_1[1]], groupA);
                    }
                }, Array_groupBy((tuple_1) => tuple_1[0], names, {
                    Equals: (x_2, y_2) => (x_2 === y_2),
                    GetHashCode: (x_2) => (stringHash(x_2) | 0),
                }));
                continue disambiguate;
            }
            break;
        }
    };
    const array_4 = disambiguate(map_1((fc_2) => {
        let fc, sc, fakeName, cLabel, matchValue_1, matchValue_2, matchValue_4;
        return [(fc = fc_2, (sc = fc.SimComponent, (fakeName = ((s_1) => (`${s_1}${sc.Id}`)), (cLabel = ((matchValue_1 = sc.Label, (matchValue_2 = sc.Type, equals(matchValue_1, "") ? ((matchValue_2.tag === 28) ? fakeName("Split") : ((matchValue_2.tag === 27) ? fakeName("Merge") : fakeName("Other"))) : matchValue_1.toLocaleUpperCase()))), (matchValue_4 = fc.fId, isEmpty(matchValue_4[1]) ? verilogNameConvert(20, cLabel) : capLength((verilogNameConvert(20, cLabel) + "$") + StringModule_Concat("", map_2((s) => verilogNameConvert(1, s), map_2(int32ToString, matchValue_4[1]))))))))), fc_2];
    }, sortBy((fc_1) => fc_1.fId, fs.FCompsByIndex, {
        Compare: (x, y) => (compareArrays(x, y) | 0),
    })));
    array_4.forEach((tupledArg_2) => {
        const fc_4 = tupledArg_2[1];
        fc_4.VerilogComponentName = tupledArg_2[0];
        iterateIndexed((portNum, _arg_2) => {
            const suffix = (fc_4.VerilogOutputName.length === 1) ? "" : (`$o${portNum}`);
            const outName = concat(fc_4.VerilogComponentName, suffix);
            fc_4.VerilogOutputName[portNum] = outName;
        }, fc_4.VerilogOutputName);
    });
}

/**
 * Name of the module generated for a memory component. Distinct from the component's own name,
 * which is already in use as the net driven by the instance: a module and a net sharing an
 * identifier is legal in some tools and rejected by others.
 */
export function memModuleName(fc) {
    return concat(fc.VerilogComponentName, "_mem");
}

/**
 * Name of the single instance of that module. Derived from the component name, which
 * writeVerilogNames has already made unique, so instances cannot collide either.
 */
export function memInstanceName(fc) {
    return concat(fc.VerilogComponentName, "_inst");
}

export function makeAsyncRomModule(moduleName, mem) {
    const aMax = (mem.AddressWidth - 1) | 0;
    const dMax = (mem.WordWidth - 1) | 0;
    const numWords = (1 << mem.AddressWidth) | 0;
    const romInits = StringModule_Concat("\n", map_1((tupledArg) => toText(`rom[${interpolate("%A%P()", [tupledArg[0]])}] = ${interpolate("%A%P()", [tupledArg[1]])};`), toArray(mem.Data)));
    return toText(`

    module ${moduleName}(q, a);
    output[${interpolate("%d%P()", [dMax])}:0] q;
    input [${interpolate("%d%P()", [aMax])}:0] a;
    reg [${interpolate("%d%P()", [dMax])}:0] rom [${interpolate("%d%P()", [numWords - 1])}:0];

    assign q = rom[a];
    integer i;
    initial
    begin
        for (i=0; i < ${numWords}; i=i+1)
        begin
            rom[i] = 0;
        end
    
        ${romInits}
    end
    endmodule
     `);
}

export function makeRomModule(moduleName, mem) {
    const aMax = (mem.AddressWidth - 1) | 0;
    const dMax = (mem.WordWidth - 1) | 0;
    const numWords = (1 << mem.AddressWidth) | 0;
    const romInits = StringModule_Concat("\n", map_1((tupledArg) => toText(`rom[${interpolate("%A%P()", [tupledArg[0]])}] = ${interpolate("%A%P()", [tupledArg[1]])};`), toArray(mem.Data)));
    return toText(`

    module ${moduleName}(q, a, clk);
    output reg [${interpolate("%d%P()", [dMax])}:0] q;
    input clk;
    input [${interpolate("%d%P()", [aMax])}:0] a;
    reg [${interpolate("%d%P()", [dMax])}:0] rom [${interpolate("%d%P()", [numWords - 1])}:0];
    always @(posedge clk) q <= rom[a];
    integer i;
    initial
    begin
        for (i=0; i < ${numWords}; i=i+1)
        begin
            rom[i] = 0;
        end
    
        ${romInits}
    end
    endmodule
     `);
}

export function makeRamModule(moduleName, mem) {
    const aMax = (mem.AddressWidth - 1) | 0;
    const dMax = (mem.WordWidth - 1) | 0;
    const numWords = (1 << mem.AddressWidth) >>> 0;
    const ramInits = StringModule_Concat("\n", map_1((tupledArg) => toText(`ram[${interpolate("%A%P()", [tupledArg[0]])}] = ${interpolate("%A%P()", [tupledArg[1]])};`), toArray(mem.Data)));
    return toText(`

    module ${moduleName}(q, a, d, we, clk);
    output reg [${interpolate("%d%P()", [dMax])}:0] q;
    input [${interpolate("%d%P()", [dMax])}:0] d;
    input [${interpolate("%d%P()", [aMax])}:0] a;
    input we, clk;
    reg [${interpolate("%d%P()", [dMax])}:0] ram [${interpolate("%d%P()", [numWords - 1])}:0];
     always @(posedge clk) begin
         if (we)
             ram[a] <= d;
         q <= ram[a];
     end

    integer i;
    initial
    begin
        for (i=0; i < ${numWords}; i=i+1)
        begin
            ram[i] = 0;
        end

        ${ramInits}
    end
    endmodule

    `);
}

export function makeAsyncRamModule(moduleName, mem) {
    const aMax = (mem.AddressWidth - 1) | 0;
    const dMax = (mem.WordWidth - 1) | 0;
    const numWords = (1 << mem.AddressWidth) >>> 0;
    const ramInits = StringModule_Concat("\n", map_1((tupledArg) => toText(`ram[${interpolate("%A%P()", [tupledArg[0]])}] = ${interpolate("%A%P()", [tupledArg[1]])};`), toArray(mem.Data)));
    return toText(`

    module ${moduleName}(q, a, d, we, clk);
    output [${interpolate("%d%P()", [dMax])}:0] q;
    input [${interpolate("%d%P()", [dMax])}:0] d;
    input [${interpolate("%d%P()", [aMax])}:0] a;
    input we, clk;
    reg [${interpolate("%d%P()", [dMax])}:0] ram [${interpolate("%d%P()", [numWords - 1])}:0];
     always @(posedge clk) begin
         if (we)
             ram[a] <= d;
     end
    // asynchronous read: q follows the addressed word without waiting for a clock edge
    assign q = ram[a];

    integer i;
    initial
    begin
        for (i=0; i < ${numWords}; i=i+1)
        begin
            ram[i] = 0;
        end

        ${ramInits}
    end
    endmodule

    `);
}

/**
 * get all the RAM and ROM modules used
 * NB at the moment each instance is made a separately named module, for simplicity
 */
export function getInstantiatedModules(profile, fs) {
    const array_2 = collect((fc) => {
        const name = memModuleName(fc);
        const matchValue = fc.FType;
        switch (matchValue.tag) {
            case 41:
                return [makeRamModule(name, matchValue.fields[0])];
            case 42:
                return [makeAsyncRamModule(name, matchValue.fields[0])];
            case 40:
                return [makeRomModule(name, matchValue.fields[0])];
            case 39:
                return [makeAsyncRomModule(name, matchValue.fields[0])];
            default:
                return [];
        }
    }, fs.FCompsByIndex);
    return append((profile.tag === 0) ? [] : ["`include \"cores/osdvu/uart.v\""], array_2);
}

export function removeHybridComps(fa) {
    return fa.filter((fc) => !isHybridComponent(fc.FType));
}

export function activeComps(fs) {
    return concat_1([fs.FClockedComps, removeHybridComps(fs.FOrderedComps)]);
}

/**
 * The bitwise operator a gate combines its inputs with, before any inversion.
 * Gate inputs are always one bit wide, so the bitwise operators are the right ones.
 */
export function getVerilogGateOp(gateType) {
    switch (gateType) {
        case "or":
        case "nor":
            return "|";
        case "xor":
        case "xnor":
            return "^";
        default:
            return "&";
    }
}

/**
 * Implement an n-input gate.
 * The inputs are combined with the un-negated operator and the result inverted once, which is
 * what an n-input NAND/NOR/XNOR gate means, and what getNInpBinaryGateReducer in EvalReference does.
 * Folding the negated operator pairwise instead would give different logic for n > 2.
 */
export function getVerilogNInputBinaryOp(cType, portConversionFn) {
    let gateType_1;
    if (cType.tag === 10) {
        const gateType = cType.fields[0];
        let terms;
        const strings = initialize(cType.fields[1], portConversionFn);
        terms = StringModule_Concat(concat(" ", getVerilogGateOp(gateType), " "), strings);
        if ((gateType_1 = gateType, (gateType_1 === "nor") ? true : ((gateType_1 === "xnor") ? true : ((gateType_1 === "and") ? false : ((gateType_1 === "or") ? false : (!(gateType_1 === "xor"))))))) {
            return concat("!(", terms, ")");
        }
        else {
            return terms;
        }
    }
    else {
        return toFail(printf("operator %A not defined"))(cType);
    }
}

/**
 * get valid Verilog constant for bus of given width (may be 1)
 * NB the digits must be hex, since they follow a 'h prefix: %A or %d would print the value in
 * decimal and Verilog would then read those digits as hex, giving a different (and too wide)
 * number. printf "%x" does not work on bigints, hence hexBignum.
 */
export function makeBits(w, c) {
    const c_1 = op_BitwiseAnd(c, op_Subtraction(op_LeftShift(fromOne(), w), fromOne()));
    return toText(`${interpolate("%d%P()", [w])}'h${hexBignum(c_1).slice(1, hexBignum(c_1).length)}`);
}

/**
 * get output port name
 */
export function getVPortOut(fc, _arg) {
    return item(_arg, fc.VerilogOutputName);
}

/**
 * Get string corresponding to output port name with its width prepended as a Verilog
 * slice.
 * All output ports are internal wire or reg definitions.
 */
export function getVPortOutWithSlice(fc, opn) {
    const name = getVPortOut(fc, opn);
    const width = item(opn, fc.Outputs).Width | 0;
    if (width === 1) {
        return name;
    }
    else {
        return ` [${interpolate("%d%P()", [width - 1])}:0] ${name}`;
    }
}

/**
 * Get string corresponding to name of signal that drives component input port
 */
export function getVPortInput(fs, fc, _arg) {
    const ipn = _arg;
    const matchValue = item(ipn, fc.InputDrivers);
    if (matchValue == null) {
        return toFail(printf("Can\'t find input driver for %A port %d"))(fc.FullName)(ipn);
    }
    else {
        const opn = matchValue[1];
        return getVPortOut(FastSimulation__ComponentAt_3B11D6BA(fs, matchValue[0]), opn);
    }
}

/**
 * Create fixed width verilog zero.
 * NB it seems this is not strictly needed, integer 0 works!
 */
export function getZeros(width) {
    if (width === 1) {
        return "1\'b0";
    }
    else {
        return `${width}'h0`;
    }
}

/**
 * what verilog declaration should the output signal have?
 */
export function fastOutputDefinition(vType, fc, opn) {
    item(opn, fc.VerilogOutputName);
    const vDef = getVPortOutWithSlice(fc, opn);
    const matchValue = fc.FType;
    const matchValue_1 = fc.AccessPath;
    let matchResult, n_1, n_2, n_3;
    switch (matchValue.tag) {
        case 31:
        case 32: {
            matchResult = 1;
            break;
        }
        case 48: {
            matchResult = 2;
            break;
        }
        case 1: {
            if (isEmpty(matchValue_1)) {
                matchResult = 0;
                n_1 = matchValue.fields[0];
            }
            else {
                matchResult = 5;
            }
            break;
        }
        case 0: {
            if (isEmpty(matchValue_1)) {
                matchResult = 3;
                n_2 = matchValue.fields[0];
            }
            else {
                matchResult = 5;
            }
            break;
        }
        case 33: {
            matchResult = 4;
            n_3 = matchValue.fields[0];
            break;
        }
        case 34: {
            matchResult = 4;
            n_3 = matchValue.fields[0];
            break;
        }
        case 35: {
            matchResult = 4;
            n_3 = matchValue.fields[0];
            break;
        }
        case 37: {
            matchResult = 4;
            n_3 = matchValue.fields[0];
            break;
        }
        case 36: {
            matchResult = 4;
            n_3 = matchValue.fields[0];
            break;
        }
        case 38: {
            matchResult = 4;
            n_3 = matchValue.fields[0];
            break;
        }
        default:
            matchResult = 5;
    }
    switch (matchResult) {
        case 0:
            return concat("output ", vDef, ";\n");
        case 1:
            return concat("reg ", vDef, " = 1\'b0;\n");
        case 2:
            return toFail(printf("Legacy Input component types should never occur"));
        case 3:
            if (vType.tag === 1) {
                return `reg ${vDef} = ${getZeros(n_2)};
`;
            }
            else {
                return concat("input ", vDef, ";\n");
            }
        case 4:
            return `reg ${vDef} = ${getZeros(n_3)};
`;
        default:
            return concat("wire ", vDef, ";\n");
    }
}

/**
 * Translates from a component to its Verilog description
 */
export function getVerilogComponent(fs, fc) {
    const ins = (i) => getVPortInput(fs, fc, i);
    const outs = (i_1) => getVPortOut(fc, i_1);
    fc.VerilogComponentName;
    const outW = (i_2) => {
        const matchValue = item(i_2, fc.Outputs).Width | 0;
        if (matchValue > 64) {
            return toFail(printf("Sorry - Verilog output does not yet work for busses > 64 bit. Output failed")) | 0;
        }
        else {
            return matchValue | 0;
        }
    };
    const matchValue_2 = fc.FType;
    let matchResult, gateType, n_5, c, w_1, n_6, n_7, n_8, n_9, n_10, op, n_11, n_12, n_13, n_14, lsb, outW_1, c_1, w_6, c_2, w_7, n_15, lsBits, n_16, outputWidths, mem, mem_1, mem_2, n_17, n_18, m, n_21, tp;
    switch (matchValue_2.tag) {
        case 2:
        case 1:
        case 3: {
            matchResult = 1;
            break;
        }
        case 4: {
            matchResult = 2;
            break;
        }
        case 8: {
            matchResult = 3;
            break;
        }
        case 32:
        case 34: {
            matchResult = 5;
            break;
        }
        case 35: {
            matchResult = 6;
            break;
        }
        case 37: {
            matchResult = 7;
            break;
        }
        case 36: {
            matchResult = 8;
            break;
        }
        case 38: {
            matchResult = 9;
            break;
        }
        case 31:
        case 33: {
            matchResult = 10;
            break;
        }
        case 9: {
            matchResult = 12;
            break;
        }
        case 14: {
            matchResult = 13;
            break;
        }
        case 15: {
            matchResult = 14;
            break;
        }
        case 16: {
            matchResult = 15;
            break;
        }
        case 11: {
            matchResult = 25;
            break;
        }
        case 12: {
            matchResult = 26;
            break;
        }
        case 13: {
            matchResult = 27;
            break;
        }
        case 27: {
            matchResult = 31;
            break;
        }
        case 28: {
            matchResult = 33;
            break;
        }
        case 26: {
            matchResult = 38;
            break;
        }
        case 48:
        case 43:
        case 45:
        case 44: {
            matchResult = 39;
            break;
        }
        case 50:
        case 51:
        case 52:
        case 53: {
            matchResult = 40;
            break;
        }
        case 10: {
            matchResult = 4;
            gateType = matchValue_2.fields[0];
            n_5 = matchValue_2.fields[1];
            break;
        }
        case 7: {
            matchResult = 11;
            c = matchValue_2.fields[1];
            w_1 = matchValue_2.fields[0];
            break;
        }
        case 49: {
            matchResult = 11;
            c = matchValue_2.fields[1];
            w_1 = matchValue_2.fields[0];
            break;
        }
        case 17: {
            matchResult = 16;
            n_6 = matchValue_2.fields[0];
            break;
        }
        case 18: {
            matchResult = 17;
            n_7 = matchValue_2.fields[0];
            break;
        }
        case 19: {
            matchResult = 18;
            n_8 = matchValue_2.fields[0];
            break;
        }
        case 20: {
            matchResult = 19;
            n_9 = matchValue_2.fields[0];
            break;
        }
        case 21: {
            matchResult = 20;
            n_10 = matchValue_2.fields[0];
            op = matchValue_2.fields[1];
            break;
        }
        case 22: {
            matchResult = 21;
            n_11 = matchValue_2.fields[0];
            break;
        }
        case 24: {
            matchResult = 22;
            n_12 = matchValue_2.fields[0];
            break;
        }
        case 23: {
            matchResult = 23;
            n_13 = matchValue_2.fields[0];
            break;
        }
        case 25: {
            matchResult = 24;
            n_14 = matchValue_2.fields[0];
            break;
        }
        case 6: {
            matchResult = 28;
            lsb = matchValue_2.fields[1];
            outW_1 = matchValue_2.fields[0];
            break;
        }
        case 47: {
            matchResult = 29;
            c_1 = matchValue_2.fields[1];
            w_6 = matchValue_2.fields[0];
            break;
        }
        case 5: {
            matchResult = 30;
            c_2 = matchValue_2.fields[1];
            w_7 = matchValue_2.fields[0];
            break;
        }
        case 29: {
            matchResult = 32;
            n_15 = matchValue_2.fields[0];
            break;
        }
        case 30: {
            matchResult = 34;
            lsBits = matchValue_2.fields[2];
            n_16 = matchValue_2.fields[0];
            outputWidths = matchValue_2.fields[1];
            break;
        }
        case 39: {
            matchResult = 35;
            mem = matchValue_2.fields[0];
            break;
        }
        case 40: {
            matchResult = 36;
            mem_1 = matchValue_2.fields[0];
            break;
        }
        case 41: {
            matchResult = 37;
            mem_2 = matchValue_2.fields[0];
            break;
        }
        case 42: {
            matchResult = 37;
            mem_2 = matchValue_2.fields[0];
            break;
        }
        case 54: {
            matchResult = 41;
            n_17 = matchValue_2.fields[0];
            break;
        }
        case 55: {
            matchResult = 42;
            n_18 = matchValue_2.fields[0];
            break;
        }
        case 46: {
            matchResult = 43;
            m = matchValue_2.fields[1];
            n_21 = matchValue_2.fields[0];
            tp = matchValue_2.fields[2];
            break;
        }
        default:
            if (equals(fc.AccessPath, empty())) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
    }
    switch (matchResult) {
        case 0:
            return toFail(printf("What? cannot call getVerilogComponent to find code for global Input"));
        case 1:
            return toText(`assign ${outs(0)} = ${ins(0)};
`);
        case 2:
            return "";
        case 3: {
            const arg_2 = outs(0);
            const arg_3 = ins(0);
            return toText(printf("assign %s = ! %s;\n"))(arg_2)(arg_3);
        }
        case 4: {
            const arg_4 = outs(0);
            const arg_5 = getVerilogNInputBinaryOp(fc.FType, ins);
            return toText(printf("assign %s = %s;\n"))(arg_4)(arg_5);
        }
        case 5:
            return `always @(posedge clk) ${outs(0)} <= ${ins(1)} ? ${ins(0)} : ${outs(0)};
`;
        case 6:
            return `always @(posedge clk) ${outs(0)} <= ${ins(2)} ? (${ins(1)} ? ${ins(0)} : (${outs(0)}+1'b1)) : ${outs(0)};
`;
        case 7:
            return `always @(posedge clk) ${outs(0)} <= ${ins(1)} ? ${ins(0)} : (${outs(0)}+1'b1) ;
`;
        case 8:
            return `always @(posedge clk) ${outs(0)} <= ${ins(0)} ? (${outs(0)}+1'b1) : ${outs(0)};
`;
        case 9:
            return `always @(posedge clk) ${outs(0)} <= (${outs(0)}+1'b1) ;
`;
        case 10:
            return `always @(posedge clk) ${outs(0)} <= ${ins(0)};
`;
        case 11:
            return `assign ${outs(0)} = ${makeBits(w_1, c)};
`;
        case 12: {
            const w_2 = outW(1) | 0;
            return (((`assign ${outs(0)} = (${ins(0)} == 2'b00) ? ${ins(1)} : ${makeBits(w_2, fromInt32(0))};
`) + (`assign ${outs(1)} = (${ins(0)} == 2'b01) ? ${ins(1)} : ${makeBits(w_2, fromInt32(0))};
`)) + (`assign ${outs(2)} = (${ins(0)} == 2'b10) ? ${ins(1)} : ${makeBits(w_2, fromInt32(0))};
`)) + (`assign ${outs(3)} = (${ins(0)} == 2'b11) ? ${ins(1)} : ${makeBits(w_2, fromInt32(0))};
`);
        }
        case 13: {
            const w_3 = outW(0) | 0;
            return (`assign ${outs(0)} = ${ins(1)} ? ${makeBits(w_3, fromInt32(0))} : ${ins(0)};
`) + (`assign ${outs(1)} = ${ins(1)} ? ${ins(0)} : ${makeBits(w_3, fromInt32(0))};
`);
        }
        case 14: {
            const w_4 = outW(0) | 0;
            return (((`assign ${outs(0)} = (${ins(1)} == 2'b00) ? ${ins(0)} : ${makeBits(w_4, fromInt32(0))};
`) + (`assign ${outs(1)} = (${ins(1)} == 2'b01) ? ${ins(0)} : ${makeBits(w_4, fromInt32(0))};
`)) + (`assign ${outs(2)} = (${ins(1)} == 2'b10) ? ${ins(0)} : ${makeBits(w_4, fromInt32(0))};
`)) + (`assign ${outs(3)} = (${ins(1)} == 2'b11) ? ${ins(0)} : ${makeBits(w_4, fromInt32(0))};
`);
        }
        case 15: {
            const w_5 = outW(0) | 0;
            return (((((((`assign ${outs(0)} = (${ins(1)} == 3'b000) ? ${ins(0)} : ${makeBits(w_5, fromInt32(0))};
`) + (`assign ${outs(1)} = (${ins(1)} == 3'b001) ? ${ins(0)} : ${makeBits(w_5, fromInt32(0))};
`)) + (`assign ${outs(2)} = (${ins(1)} == 3'b010) ? ${ins(0)} : ${makeBits(w_5, fromInt32(0))};
`)) + (`assign ${outs(3)} = (${ins(1)} == 3'b011) ? ${ins(0)} : ${makeBits(w_5, fromInt32(0))};
`)) + (`assign ${outs(4)} = (${ins(1)} == 3'b100) ? ${ins(0)} : ${makeBits(w_5, fromInt32(0))};
`)) + (`assign ${outs(5)} = (${ins(1)} == 3'b101) ? ${ins(0)} : ${makeBits(w_5, fromInt32(0))};
`)) + (`assign ${outs(6)} = (${ins(1)} == 3'b110) ? ${ins(0)} : ${makeBits(w_5, fromInt32(0))};
`)) + (`assign ${outs(7)} = (${ins(1)} == 3'b111) ? ${ins(0)} : ${makeBits(w_5, fromInt32(0))};
`);
        }
        case 16: {
            const cin = ins(0);
            const a = ins(1);
            const b = ins(2);
            const sum = outs(0);
            return `assign {${outs(1)},${sum} } = ${a} + ${b} + ${cin};
`;
        }
        case 17: {
            const a_1 = ins(0);
            const b_1 = ins(1);
            const sum_1 = outs(0);
            return `assign {${outs(1)},${sum_1} } = ${a_1} + ${b_1} ;
`;
        }
        case 18: {
            const cin_1 = ins(0);
            const a_2 = ins(1);
            const b_2 = ins(2);
            return `assign ${outs(0)} = ${a_2} + ${b_2} + ${cin_1};
`;
        }
        case 19: {
            const a_3 = ins(0);
            const b_3 = ins(1);
            return `assign ${outs(0)} = ${a_3} + ${b_3} ;
`;
        }
        case 20: {
            const a_4 = ins(0);
            const b_4 = ins(1);
            const xor = outs(0);
            if (op != null) {
                return `assign ${xor} = ${a_4} * ${b_4};
`;
            }
            else {
                return `assign ${xor} = ${a_4} ^ ${b_4};
`;
            }
        }
        case 21: {
            const a_5 = ins(0);
            const b_5 = ins(1);
            return `assign ${outs(0)} = ${a_5} & ${b_5};
`;
        }
        case 22: {
            const a_6 = ins(0);
            const b_6 = ins(1);
            return `assign ${outs(0)} = ${a_6} | ${b_6};
`;
        }
        case 23: {
            const a_7 = ins(0);
            return `assign ${outs(0)} = ~${a_7};
`;
        }
        case 24: {
            const a_8 = ins(0);
            return `assign ${outs(0)} = ${a_8} ? ${n_14}'b${fold((s, v) => (s + "1"), "", toList(rangeDouble(1, 1, n_14)))} : ${n_14}'b0;
`;
        }
        case 25:
            return `assign ${outs(0)} = ${ins(2)} ? ${ins(1)} : ${ins(0)};
`;
        case 26:
            return `assign ${outs(0)} = ${ins(4)}[1] ? (${ins(4)}[0] ? ${ins(3)} : ${ins(2)}) : (${ins(4)}[0] ? ${ins(1)} : ${ins(0)})  ;
`;
        case 27:
            return `assign ${outs(0)} = ${ins(8)}[2] ? (${ins(8)}[1] ? (${ins(8)}[0] ? ${ins(7)} : ${ins(6)}) : (${ins(8)}[0] ? ${ins(5)} : ${ins(4)})) : (${ins(8)}[1] ? (${ins(8)}[0] ? ${ins(3)} : ${ins(2)}) : (${ins(8)}[0] ? ${ins(1)} : ${ins(0)}))  ;
`;
        case 28: {
            let sel;
            const arg_6 = ((outW_1 + lsb) - 1) | 0;
            sel = toText(printf("[%d:%d]"))(arg_6)(lsb);
            return `assign ${outs(0)} = ${ins(0)}${sel};
`;
        }
        case 29:
            return `assign ${outs(0)} = ${ins(0)} == ${makeBits(w_6, c_1)};
`;
        case 30:
            return `assign ${outs(0)} = ${ins(0)} == ${makeBits(w_7, c_2)};
`;
        case 31:
            return `assign ${outs(0)} = { ${ins(1)},${ins(0)} };
`;
        case 32: {
            const mergedInputs = StringModule_Concat("", toArray_1(delay(() => map((i_4) => ((i_4 === 0) ? ins(i_4) : concat(ins(i_4), ",")), rangeDouble(n_15 - 1, -1, 0)))));
            return `assign ${outs(0)} = { ${mergedInputs} };
`;
        }
        case 33: {
            const lsbBits = outW(0) | 0;
            const msbBits = outW(1) | 0;
            return (`assign ${outs(0)} = ${ins(0)}[${interpolate("%d%P()", [lsbBits - 1])}:0];
`) + (`assign ${outs(1)} = ${ins(0)}[${interpolate("%d%P()", [(msbBits + lsbBits) - 1])}:${interpolate("%d%P()", [lsbBits])}];
`);
        }
        case 34:
            return fold((accstr, outstr) => (accstr + outstr), "", map3((index_1, width, lsb_1) => {
                const msb = ((width + lsb_1) - 1) | 0;
                return `assign ${outs(index_1)} = ${ins(0)}[${interpolate("%d%P()", [msb])}:${interpolate("%d%P()", [lsb_1])}];
`;
            }, toList(rangeDouble(0, 1, n_16 - 1)), outputWidths, lsBits));
        case 35:
            return `${memModuleName(fc)} ${memInstanceName(fc)} (${outs(0)}, ${ins(0)});
`;
        case 36:
            return `${memModuleName(fc)} ${memInstanceName(fc)} (${outs(0)}, ${ins(0)}, clk);
`;
        case 37:
            return `${memModuleName(fc)} ${memInstanceName(fc)} (${outs(0)}, ${ins(0)}, ${ins(1)}, ${ins(2)}, clk);
`;
        case 38:
            return toFail(printf("What? custom components cannot exist in fast Simulation data structure"));
        case 39:
            return toFail(`Invalid legacy component type '${fc.FType}'`);
        case 40:
            return toFail(`Array sheet IO is removed by expansion and cannot reach Verilog output: '${fc.FType}'`);
        case 41: {
            const inputs = StringModule_Concat(",", toArray_1(delay(() => map(ins, rangeDouble(n_17 - 1, -1, 0)))));
            return `assign ${outs(0)} = { ${inputs} };
`;
        }
        case 42: {
            const sel_1 = ins(n_18);
            const w_8 = item(0, fc.Outputs).Width | 0;
            const selW = item(n_18, fc.InputLinks).Width | 0;
            const chain = fold((acc, i_6) => (acc + (`(${sel_1} == ${makeBits(selW, fromInt32(i_6))}) ? ${ins(i_6)} : `)), "", toList(rangeDouble(0, 1, n_18 - 1)));
            return `assign ${outs(0)} = ${chain}${makeBits(w_8, fromZero())};
`;
        }
        default: {
            const input = ins(0);
            const shifter = ins(1);
            const output = outs(0);
            switch (tp.tag) {
                case 1:
                    return `assign ${output} = ${input} >> ${shifter};
`;
                case 2:
                    return `assign ${output} = $signed(${input}) >>> ${shifter};
`;
                default:
                    return `assign ${output} = ${input} << ${shifter};
`;
            }
        }
    }
}

/**
 * return the header of the main verilog module with hardware inputs and outputs in header.
 */
export function getMainHeader(vType, profile, fs) {
    let header, array_2, clock;
    return [(header = StringModule_Concat(",\n\t", (array_2 = collect((fc_1) => {
        const matchValue = fc_1.FType;
        const matchValue_1 = fc_1.AccessPath;
        let matchResult;
        switch (matchValue.tag) {
            case 1: {
                if (isEmpty(matchValue_1)) {
                    matchResult = 0;
                }
                else {
                    matchResult = 2;
                }
                break;
            }
            case 0: {
                if (isEmpty(matchValue_1)) {
                    if (equals(vType, VMode.ForSynthesis)) {
                        matchResult = 1;
                    }
                    else {
                        matchResult = 2;
                    }
                }
                else {
                    matchResult = 2;
                }
                break;
            }
            case 48: {
                if (isEmpty(matchValue_1)) {
                    if (equals(vType, VMode.ForSynthesis)) {
                        matchResult = 1;
                    }
                    else {
                        matchResult = 2;
                    }
                }
                else {
                    matchResult = 2;
                }
                break;
            }
            default:
                matchResult = 2;
        }
        switch (matchResult) {
            case 0:
                return [item(0, fc_1.VerilogOutputName)];
            case 1:
                return [item(0, fc_1.VerilogOutputName)];
            default:
                return [];
        }
    }, append(fs.FGlobalInputComps, fs.FOrderedComps.filter((fc) => (isOutput(fc.FType) && equals(fc.AccessPath, empty()))))), append((vType.tag === 1) ? [] : ((profile.tag === 1) ? ["debug_clk", "RS232_Rx_TTL", "RS232_Tx_TTL"] : ["clk"]), array_2))), (clock = ((vType.tag === 0) ? ((profile.tag === 1) ? "input debug_clk;\ninput RS232_Rx_TTL;\noutput RS232_Tx_TTL;" : "input clk;") : ""), concat("module main", (header === "") ? "" : concat(" (\n\t", header, ")"), ";\n", clock)))];
}

/**
 * return the wire and reg definitions needed to make the verilog design work.
 */
export function getMainSignalDefinitions(vType, profile, fs) {
    const array_4 = sort(collect((fc_1) => mapIndexed((i, _arg) => fastOutputDefinition(vType, fc_1, i), fc_1.Outputs), fs.FCompsByIndex.filter((fc) => fc.Active)), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    return append((vType.tag === 0) ? ((profile.tag === 1) ? ["wire clk;\n"] : []) : ["reg clk;\n"], array_4);
}

/**
 * get the verilog statements output from each component
 * NB a hybrid component (AsyncRAM1) is in both FClockedComps and FOrderedComps, since it has both
 * clocked and combinational behaviour. Its Verilog describes the whole component, so it must be
 * written once: activeComps drops the hybrid copy from the combinational half.
 */
export function getMainHardware(fs) {
    return map_1((fc) => getVerilogComponent(fs, fc), activeComps(fs));
}

/**
 * make a simple testbench which displays module outputs for the first 30 clock cycles
 */
export function getInitialSimulationBlock(vType, fs) {
    const inDefs = StringModule_Concat("\n                    ", map_1((fc) => {
        const width = item(0, fc.Outputs).Width | 0;
        return concat(item(0, fc.VerilogOutputName), " = ", makeBits(width, fromZero()), ";");
    }, fs.FGlobalInputComps));
    let patternInput;
    const tupledArg = unzip(map_1((fc_1) => {
        const sigName_1 = item(0, fc_1.VerilogOutputName);
        let hexWidth;
        const w = item(0, fc_1.Outputs).Width | 0;
        if (w <= 0) {
            toFail(`Unexpected width (${w})in verilog output for ${fc_1.FullName}`);
        }
        hexWidth = (~~((w - 1) / 4) + 1);
        const heading = fc_1.VerilogComponentName;
        const heading_1 = replicate(max(0, hexWidth - heading.length), " ") + heading;
        return [heading_1, [max(hexWidth, heading_1.length), sigName_1]];
    }, fs.FCompsByIndex.filter((_arg) => {
        let matchResult;
        if (_arg.FType.tag === 1) {
            if (isEmpty(_arg.AccessPath)) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    })));
    patternInput = [tupledArg[0], unzip(tupledArg[1])];
    const outNames_1 = StringModule_Concat(" ", patternInput[0]);
    const outFormat_1 = StringModule_Concat(" ", map_1((width_1) => ("%" + (`${width_1}h`)), patternInput[1][0]));
    const outVars_1 = StringModule_Concat(",", patternInput[1][1]);
    if (vType.tag === 1) {
        return [`
            initial
                    begin
                    ${inDefs}
                    clk = 1'b0;
                    #10
                    $display("${outNames_1}");
                    while ($time < 300)
                    begin
                        $display("${outFormat_1}",${outVars_1});
                        #5 clk = ~clk;
                        #5 clk = ~clk;
                    end
                    end
        `];
    }
    else {
        return [];
    }
}

export function getDebugController(profile, fs) {
    const comps_2 = StringModule_Concat("\n", append(mapIndexed((i_1, s) => (`    "${format('{0:' + "x2" + '}', i_1)}": tx_byte <= { ${s} };`), map_1((a) => toArray_2(take(8, append_1(ofArray(a), replicate_1(8, "1\'b0")))), chunkBySize(8, collect((tupledArg) => map_1((i) => (`${tupledArg[0]}[${i}]`), Int32Array.from(rangeDouble(0, 1, tupledArg[1] - 1))), map_1((fc_1) => [getVPortOut(fc_1, 0), item(0, fc_1.Outputs).Width], fs.FOrderedComps.filter((fc) => {
        if (fc.FType.tag === 2) {
            return true;
        }
        else {
            return false;
        }
    })))))), ["    default: tx_byte <= 8\'hFF;"]));
    if (profile.tag === 1) {
        return [concat("\r\nwire RS232_Rx_TTL;\r\nwire RS232_Tx_TTL;\r\nwire reset = 0;\r\nreg transmit = 0;\r\nreg [7:0] tx_byte = 0;\r\nwire received;\r\nwire [7:0] rx_byte;\r\nwire is_receiving;\r\nwire is_transmitting;\r\nwire recv_error;\r\nreg [3:0] num_received = 0;\r\nreg [31:0] received_bytes = 0;\r\nuart #(.baud_rate(9600), .sys_clk_freq(12000000))\r\nuart0(\r\n    .clk(debug_clk),\r\n    .rst(reset),\r\n    .rx(RS232_Rx_TTL),\r\n    .tx(RS232_Tx_TTL),\r\n    .transmit(transmit),\r\n    .tx_byte(tx_byte),\r\n    .received(received),\r\n    .rx_byte(rx_byte),\r\n    .is_receiving(is_receiving),\r\n    .is_transmitting(is_transmitting),\r\n    .recv_error(recv_error),\r\n);\r\nreg single_step = 0;\r\nreg is_running = 0;\r\nreg clk_is_active = 0;\r\nassign clk = debug_clk & clk_is_active;\r\nalways @ (negedge debug_clk) begin\r\n    clk_is_active <= 0;\r\n    if (single_step)\r\n        clk_is_active <= 1;\r\n    if (is_running)\r\n        clk_is_active <= 1;\r\nend\r\nalways @ (posedge debug_clk) begin\r\n    transmit <= 0;\r\n    single_step <= 0;\r\n    if (received) begin\r\n        num_received <= num_received + 1;\r\n        received_bytes <= { received_bytes [23:0], rx_byte };\r\n    end\r\n    if (num_received == 4\'d1) begin\r\n        if (received_bytes[7:0] == 8\'h53/*S*/) begin\r\n            num_received <= 4\'h0;\r\n            single_step <= 1;\r\n        end\r\n    if (received_bytes[7:0] == 8\'h43/*C*/) begin\r\n            num_received <= 4\'h0;\r\n            is_running <= 1;\r\n        end\r\n        if (received_bytes[7:0] == 8\'h50/*P*/) begin\r\n            num_received <= 4\'h0;\r\n            is_running <= 0;\r\n        end\r\n    end else if (num_received == 4\'d3) begin\r\n        if (received_bytes[23:16] == 8\'h52/*R*/) begin // Read value of internal registers/wires\r\n            num_received <= 4\'h0;\r\n            transmit <= 1;\r\n            case (received_bytes[15:0])\r\n            ", comps_2, "\r\n            endcase\r\n        end\r\n    end\r\nend\r\n")];
    }
    else {
        return [];
    }
}

/**
 * Outputs a string which contains a single verilog file with the hardware in verilog form.
 * The top-level simulation moudle is called main - other modules may be included for RAM & ROM
 * this can be called any time after after buildFastSimulation has created the initial FastSimulation
 * data structure.
 * To simulate this you would need to set up clk as a clock input, and provide stimulus for other inputs if
 * there are any.
 */
export function getVerilog(vType, fs, profile) {
    writeVerilogNames(fs);
    return StringModule_Concat("\n", map_1((strings) => StringModule_Concat("", strings), [getInstantiatedModules(profile, fs), getMainHeader(vType, profile, fs), getMainSignalDefinitions(vType, profile, fs), getMainHardware(fs), getInitialSimulationBlock(vType, fs), getDebugController(profile, fs), ["endmodule\n"]]));
}

